<template>
    <div class="flex flex-col w-full p-5 gap-3">
        <app-filter ref="filter" v-model="filterAsString" @input="updateState"></app-filter>
        <table class="text-xs border w-full">
            <thead>
                <th class="p-1 border">{{ $t('commons.code') }}</th>
                <th class="p-1 border">{{ $t('organizations.subscription') }}</th>
                <th class="p-1 border">{{ $t('commons.name') }}</th>
                <th class="p-1 border">{{ $t('commons.city') }}</th>
            </thead>
            <tr v-for="project in filteredProjects">
                <td class="p-1 border">{{ project.code }}</td>
                <td class="p-1 border" v-if="project.subscription">{{ project.subscription?.code }}</td>
                <td class="p-1 border" v-else>{{ $t('organizations.starterOffer') }}</td>
                <td class="p-1 border">
                    <router-link :to="{ name: 'myDashboard', params: { projectId: project.id } }" class="underline">
                        {{ project.name }}
                    </router-link>
                </td>
                <td class="p-1 border">{{ project.city }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import { getOrganizationProjects } from '@/features/organizations/organizations.service';
import { filterMatch } from '@/services/sanitize.service';
import AppFilter from '@/components/appFilter/AppFilter.vue';

export default {
    components: { AppFilter },
    created() {
        this.init();
    },
    watch: {
        $route() {
            this.init();
        },
    },
    computed: {
        filteredProjects() {
            return this.projects.filter((item) => filterMatch(item.filterString, this.filterAsString, true));
        },
    },
    methods: {
        updateState() {
            localStorage.setItem('organizations.projectFilter', this.filterAsString);
        },
        async init() {
            this.filterAsString = localStorage.getItem('organizations.projectFilter') || '';
            this.projects = (await getOrganizationProjects(this.$route.params.organizationId)).map((project) => ({
                ...project,
                filterString: project.code + '_' + project.name + '_' + project.city,
            }));
        },
    },
    data() {
        return {
            projects: [],
            filterAsString: '',
        };
    },
};
</script>
